var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[("" + _vm.cssPrefix)]},[_c('div',{staticClass:"help-container__scroll__inner helpContainer",domProps:{"innerHTML":_vm._s(_vm.helplink)}})])}
var staticRenderFns = []

export { render, staticRenderFns }